import { h } from 'preact';
import { useContext } from 'preact/compat';
import { decodeEntities } from '@wordpress/html-entities';
import { Theme } from '../lib/render';
import { purifyHTML } from '../lib/purify';

/**
 * Donation Form topper text.
 */
const Intro = () => {
	const theme = useContext(Theme);

	return (
		<div className={[
			'ea-intro',
			`${theme.donate_type}`,
		].join(' ')}
		>
			{theme.title && (
				<h1 className="ea-intro__title">
					{decodeEntities(theme.title)}
				</h1>
			)}
			{theme.desc && (
				<div className="ea-intro__deck" dangerouslySetInnerHTML={{ __html: purifyHTML(theme.desc) }} />
			)}
		</div>
	);
};

export default Intro;
